export type TabId = 'prehled' | 'ulohy' | 'sluzby' | 'reporty' | 'faktury' | 'spravy';

export const tabMeta: Record<TabId, { title: string; sub: string }> = {
  prehled: { title: 'Dobré ráno, Ján!', sub: 'Posledná aktualizácia pred 5 minútami' },
  ulohy: { title: 'Vaše úlohy', sub: '2 úlohy čakajú na váš vstup' },
  sluzby: { title: 'Moje služby', sub: 'Prehľad aktívnych objednávok' },
  reporty: { title: 'Mesačné reporty', sub: '4 reporty k dispozícii na stiahnutie' },
  faktury: { title: 'Faktúry', sub: '1 faktúra čaká na uhradenie' },
  spravy: { title: 'Správy', sub: '1 nová správa od Boostio' },
};
